module.exports = __webpack_public_path__ + "media/FinalView.13862aef.jpg";